import { SCALE_DENOMINATORS } from "../constants";

// Free-form zooming leaves the denominator on an arbitrary value, and snapping to a rung leaves it
// on one with a float error. Requiring a step of at least 0.1% keeps the buttons from getting stuck
// on the rung they just landed on.
const MIN_RELATIVE_STEP = 0.001;

/**
 * @name getAdjacentScaleDenominator
 * @description The next rung of the scale ladder in the given direction, or `null` at its ends.
 * | Zooming in shrinks the denominator (1:1000 -> 1:500), zooming out grows it.
 */
function getAdjacentScaleDenominator({ scaleDenominator, direction }: { scaleDenominator: number; direction: "in" | "out" }): number | null {
	if (direction === "in") {
		const smaller = SCALE_DENOMINATORS.filter((x) => x < scaleDenominator * (1 - MIN_RELATIVE_STEP));
		return smaller.at(-1) ?? null;
	}

	const larger = SCALE_DENOMINATORS.filter((x) => x > scaleDenominator * (1 + MIN_RELATIVE_STEP));
	return larger.at(0) ?? null;
}

export { getAdjacentScaleDenominator };
